<template>
	<div id="facilityCloud">
		<div id="headerContent">
			<home-header  :navName="navName"></home-header>
			<div class="nav_name">装备</div>
			<div class="nav_name_info">
				<p>打造基于不同设备的多种保障型装备，集数据产品、软件应用、硬件装备于一体，</p>
				<p>适用于不同场景的使用需求。</p>
			</div>
		</div>
		<div id="bodyer">
			<div class="infosContent"
						v-show="infosContent"
			>
			 <div class="header">
			 		<div class="close" title="关闭" @click="closeInfoClick()">X</div>
			 </div>
			 <div class="body" v-html="infosContentHtml">
			 </div>
			</div>
			<div id="cloumControl" v-show="!infosContent">
				<div class="facility_map cloum-control"
							:class="{active:'facility_map' == cloumName}"
							@click="cloumClick('facility_map')"
				>
					<div class="content">
						<div class="icon_map"></div>
						<div class="name">全息地图云</div>
					</div>
				</div>
				<div class="facility_pc cloum-control"
							:class="{active:'facility_pc' == cloumName}"
							@click="cloumClick('facility_pc')"
				>
					<div class="content">
						<div class="icon_pc"></div>
						<div class="name">智能地图终端</div>
					</div>
				</div>
			</div>
			<div v-show="!infosContent">
				<div v-show="facility_pc">
					<ul>
						<li class="facilityCloud_li"
								v-for="(item,index) of facilityCloudData"
								:class="{facilityCloud_li_inverse:item.inverse}"
								:key="item.gcms_id"
						>
							<div class="images">
								<div class="li_cell">
									<div class="imgcontent">
										<img :src="item.image">
									</div>
								</div>
							</div>
							<div class="infos">
								<div class="li_cell">
									<div class="list_name">{{item.title}}</div>
									<div class="list_info" v-html="item.content"></div>
									<div class="showInfo" @click="showInfos(item.html)">
										<!-- <router-link :to="{path:'showInfo',query:{gcmsid:item.gcms_id,gcmsname:'facility_cloud'}}">
											<p>查看详情</p><div class="bg"></div>
										</router-link> -->
											<p>查看详情</p><div class="bg"></div>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div v-show="!facility_pc">
					<ul>
						<li class="facilityCloud_li"
								v-for="(item,index) of facilityTerminalData"
								:class="{facilityCloud_li_inverse:item.inverse}"
								:key="item.gcms_id"
						>
							<div class="images">
								<div class="li_cell">
									<div class="imgcontent">
										<img :src="item.image">
									</div>
								</div>
							</div>
							<div class="infos">
								<div class="li_cell">
									<div class="list_name">{{item.title}}</div>
									<div class="list_info" v-html="item.content"></div>
									<div class="showInfo" @click="showInfos(item.html)">
										<!-- <router-link :to="{path:'showInfo',query:{gcmsid:item.gcms_id,gcmsname:'facility_cloud'}}">
											<p>查看详情</p><div class="bg"></div>
										</router-link> -->
											<p>查看详情</p><div class="bg"></div>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
    <connect-part></connect-part>
		<home-footer></home-footer>
	</div>
</template>
<script>
import axios from 'axios'
import HomeHeader from './header'
import ConnectPart from './connect'
import HomeFooter from './footer'
export default {
	name: 'facilityCloud',
	components:{
		HomeHeader:HomeHeader,
    ConnectPart:ConnectPart,
		HomeFooter:HomeFooter
	},
	data: function() {
			return {
				listdata:"",
				navName:"facility",
				listLength:null,
				num:0,
				facilityCloudData:[],
				facilityTerminalData:[],
				inverse:true,
				terminalInverse:true,
				cloumName:'facility_map',
				facility_pc:true,
				infosContent:false,
				infosContentHtml:null
			}
	},
	methods:{
		showInfos:function(html){
			this.infosContentHtml = html;
			this.infosContent=true;
      $("html").scrollTop(330);
		},
		closeInfoClick:function(){
			this.infosContent=false;
		},
		getGcmsList:function(){
			if(this.facilityCloudData.length == 0){
				axios.get(xdc_app_config.gcms_server+'/content/facilitry_cloud')
					.then(this.updateData)
			}
		},
		updateData:function(data){
			this.listdata = data.data.data;
			this.listLength = data.data.data.length;
			this.num=0;
			var num = this.num;
			this.addFacility(num)
		},
		addFacility:function(num){
			if(num<this.listLength){
				var gcmsid  = this.listdata[num].gcms_id;
				axios.get(xdc_app_config.gcms_server+'/content/facilitry_cloud/'+gcmsid)
					.then(this.upFacility)
			}else{
				return false;
			}
		},
		upFacility:function(res){
			var curdata = res.data.data;
			this.inverse = !this.inverse;
			var itemData = {
				gcms_id:curdata.gcms_id,
				title:curdata.gcms_title,
				content:curdata.introduction,
				image:xdc_app_config.gcms_server+"/file"+curdata.thumbnail,
				inverse:this.inverse,
				html:curdata.content
			}
			this.facilityCloudData.push(itemData);
			this.num++;
			var num = this.num;
			this.addFacility(num);
		},
		cloumClick:function(name){
			this.cloumName = name;
			this.infosContent=false;
			this.facility_pc = !this.facility_pc;
			if(this.facilityTerminalData.length == 0){
				this.getfacilityTerminalData()
			}
		},
		getfacilityTerminalData:function(){
			axios.get(xdc_app_config.gcms_server+'/content/facility_terminal')
					.then(this.updateTerminal)
		},
		updateTerminal:function(data){
				this.listdata = data.data.data;
				this.listLength = data.data.data.length;
				this.num=0;
				var num = this.num;
				this.addfacilityTerminal(num);
		},
		addfacilityTerminal:function(num){
			if(num<this.listLength){
				var gcmsid  = this.listdata[num].gcms_id;
				axios.get(xdc_app_config.gcms_server+'/content/facility_terminal/'+gcmsid)
					.then(this.updatefacilityTerminalData)
			}else{
				return false;
			}
		},
		updatefacilityTerminalData:function(res){
			var curdata = res.data.data;
			this.inverse = !this.inverse;
			var itemData = {
				gcms_id:curdata.gcms_id,
				title:curdata.gcms_title,
				content:curdata.introduction,
				image:xdc_app_config.gcms_server+"/file"+curdata.thumbnail,
				inverse:this.inverse,
				html:curdata.content
			}
			this.facilityTerminalData.push(itemData);
			this.num++;
			var num = this.num;
			this.addfacilityTerminal(num);
		}
	},
	mounted:function(){
		this.getGcmsList();
    $(window).scroll(function(event){
      if(window.scrollY <= 300){
        $("#headerContent #header").css("background","none");
      }
    });
	},
	updated:function(){
		var arry = $('.infosContent').find('img');
		for(var i=0;i< arry.length;i++){
			var src = arry.eq(i).attr('src');
			if(src){
				$(arry.eq(i)).attr('src',src);
			}
		}
	}
}
</script>
<style scoped>
#headerContent{
	width: 100%;
	height: 400px;
	background: url(../../assets/images/facility/facility_header.png);
	position: relative;
	background-size: 100%;
}
#headerContent .nav_name{
	width: 100%;
	position: absolute;
	top: 146px;
	height: 37px;
	line-height: 37px;
	font-size: 37px;
	color: #fff;
	text-align: center;
}
#headerContent .nav_name_info{
	width: 100%;
	position: absolute;
	top: 228px;
	height: 18px;
	line-height: 18px;
	font-size: 18px;
	color: #d4def4;
}
#headerContent .nav_name_info p{
	width: 100%;
	text-align: center;
	margin-bottom: 10px;
}
#headerContent >>> #header{
	background: none;
}
#headerContent >>>  #header .right li{
	border-bottom: 0px;
}
#headerContent >>>  #header .right li:hover,
#headerContent >>>  #header .right li.active{
	border-bottom: 4px solid #00bbf8;
	color: #ffffff;
}
#headerContent >>>  #header .right li a{
	color: #ccd1df;
	padding: 10px 0px;
}
#headerContent >>>  #header .right li:hover a,
#headerContent >>>  #header .right li.active a{
	color: #ffffff;
}
#facilityCloud #bodyer{
	width: 100%;
	position: relative;
}
#facilityCloud #bodyer .infosContent{
	margin-top: 0px;
}
#facilityCloud #bodyer .infosContent .header{
	height: 50px;
}
#facilityCloud #bodyer .infosContent .header .close{
	float: right;
	margin-right: 50px;
	width: 30px;
	height: 30px;
	margin-top: 30px;
	border: 1px solid #747779;
	border-radius: 50px;
	font-size: 20px;
	line-height: 30px;
	text-align: center;
	cursor: pointer;
}
#facilityCloud #bodyer #cloumControl{
	width: 1200px;
	height: 106px;
	position: absolute;
	top: -54px;
	left: 50%;
	margin-left: -600px;
	background: #fff;
}
#cloumControl .cloum-control{
	position: relative;
	width: 50%;
	height: 100%;
	float: left;
	border-bottom: 7px solid #fff;
	box-shadow: 0px 4px 0px 0px #f7f5f5;
	cursor: pointer;
}
#cloumControl .cloum-control.active{
	border-bottom: 7px solid #00bbf8;
	box-shadow: 0px 0px 0px 0px #dad9d9;
}
#cloumControl .facility_map .content{
	width: 150px;
	height: 30px;
	margin: 40px auto;
	font-size: 17px;
	color: #57595e;
	margin-left: 14px;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -15px;
	margin-left: -75px;
}
#cloumControl .cloum-control .content .name{
	margin-left: 44px;
	margin-top: 6px;
}
#cloumControl .facility_map .content .icon_map{
	width: 30px;
	height: 26px;
	background:url(../../assets/images/facility/facility_map.png) center center no-repeat;
	float: left;
}
#cloumControl .facility_pc .content .icon_pc{
	width: 30px;
	height: 26px;
	background:url(../../assets/images/facility/facility_pc.png) center center no-repeat;
	float: left;
}
#cloumControl .facility_pc .content{
	width: 170px;
	height: 30px;
	margin: 40px auto;
	font-size: 17px;
	color: #57595e;
	float: left;
	margin-left: 14px;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -15px;
	margin-left: -85px;
}
#facilityCloud #bodyer ul{
	width: 100%;
	padding-top: 55px;
}
#facilityCloud #bodyer ul li{
	height: 370px;
	width: 100%;
}
#facilityCloud #bodyer .facilityCloud_li{
	background: #ffffff;
}
#facilityCloud #bodyer .facilityCloud_li .images{
	float: right;
	width: 50%;
	height: 100%;
}
#facilityCloud #bodyer .facilityCloud_li .images .li_cell{
	width: 600px;
	height: 100%;
	float: left;
	position: relative;
}
#facilityCloud #bodyer .imgcontent{
	position: absolute;
	top: 50%;
	left: 50%;
	margin-left: -300px;
	margin-top: -185px;
	width: 600px;
	height: 370px;
}
#facilityCloud #bodyer .images img{
	width: 100%;
	height: 100%;
}
#facilityCloud #bodyer .facilityCloud_li .infos{
	float: left;
	width: 50%;
}
#facilityCloud #bodyer .facilityCloud_li .infos .li_cell{
	width: 600px;
	height: 100%;
	float: right;
}
#facilityCloud #bodyer .facilityCloud_li_inverse{
	background: #f6f6f6;
}#facilityCloud #bodyer .facilityCloud_li_inverse .images{
	float: left;
	width: 50%;
	height: 100%;
}
#facilityCloud #bodyer .facilityCloud_li_inverse .images .li_cell{
	width: 600px;
	height: 100%;
	float: right;
	position: relative;
}
#facilityCloud #bodyer .facilityCloud_li_inverse .infos{
	float: right;
	width: 50%;
}
#facilityCloud #bodyer .facilityCloud_li_inverse .infos .li_cell{
	width: 600px;
	height: 100%;
	float: left;
}
#facilityCloud #bodyer .infos .list_name{
	margin-top: 79px;
	width: 100%;
	height: 15px;
	line-height: 15px;
	font-size: 15px;
	color: #2c2f35;
	text-align: center;
}
#facilityCloud #bodyer .infos .list_info{
	color: #666666;
	width: 400px;
	margin: 0 auto;
	margin-top: 30px;
	font-size: 12px;
	line-height: 24px;
}
#facilityCloud #bodyer >>> .icon_point{
	display: inline-block;
	width: 6px;
	height: 6px;
	background: #747779;
	border-radius: 12px;
	margin-right: 5px;
	margin-top: -5px;
}
#facilityCloud #bodyer .infos >>> .scenario{
	height: 12px;
	margin-top: 15px;
	width: 100%;
}
#facilityCloud #bodyer .infos >>> .scenario .name{
	color: #9a9b9c;
	width: 75px;
	float: left;
}
#facilityCloud #bodyer .infos >>> .scenario .list{
	color: #8b8d8f;
	margin-right: 20px;
	float: left;
}
#facilityCloud #bodyer .infos .showInfo{
	height: 32px;
	width: 85px;
	margin-left: 99px;
	margin-top: 22px;
	background: #00bbf8;
	border-radius: 22px;
	cursor: pointer;
}
#facilityCloud #bodyer .infos .showInfo p{
	color: #fff;
	font-size: 12px;
	line-height: 30px;
	text-indent: 10px;
	float: left;
}
#facilityCloud #bodyer .infos .showInfo .bg{
	background: url(../../assets/images/facility/icon_link.png);
	width: 7px;
	height: 12px;
	float: left;
	margin-left: 9px;
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/facilityCloud.vue